module.exports = __webpack_public_path__ + "static/angular-aedf20ee9ffee398e22bb320d118024e.png";